package fr.frux.core.designsystem.zoom

internal actual val wheelDeltaPerNotch: Float = 100f
